import { Link, LinkSize, RemoveIcon } from '@dreryk/react-components';

type MedicalInformationRemoveLinkProps = Readonly<{ onClick: VoidFunction }>;

export const MedicalInformationRemoveLink = (props: MedicalInformationRemoveLinkProps): JSX.Element => {
   return (
      <Link testId={'medicalInformationRemove'} size={LinkSize.BIG} onClick={props.onClick} icon={<RemoveIcon />} />
   );
};
